import React, { useContext } from 'react';
import './Results.scss';
import { layoutContext } from '../DORAAssessment';
import Stats from '../Stats/Stats';
import { ArrowRight16, Pdf16 } from '@carbon/icons-react';

interface resultsProps {
  contents: any;
}

const Results = (resultsProps: resultsProps) => {
  const { contents } = resultsProps;
  const { selectedItems } = useContext(layoutContext);
  const parentClass = 'dora-assessment__results';
  const selectedItemsArray = Object.values(selectedItems);

  const resultCalc = () => {
    let countYes = 0;
    let countNo = 0;
    let resultObject = {
      title: '',
      subtitle: '',
      imageName: '',
    };
    selectedItemsArray.forEach((item: any) => item === 'yes' && countYes++);
    selectedItemsArray.forEach((item: any) => item === 'no' && countNo++);
    if (countYes >= 5) {
      resultObject = {
        title: 'resultsTitleGreen',
        subtitle: 'resultsSubtitleGreen',
        imageName: 'positive',
      };
    } else if (countYes <= 2 && countNo >= 2) {
      resultObject = {
        title: 'resultsTitleRed',
        subtitle: 'resultsSubtitleRed',
        imageName: 'negative',
      };
    } else {
      resultObject = {
        title: 'resultsTitleYellow',
        subtitle: 'resultsSubtitleYellow',
        imageName: 'neutral',
      };
    }
    return resultObject;
  };
  const resultObject = resultCalc();

  const getContryCode = () => {
    const lang =
      document.getElementsByTagName('html')[0].getAttribute('lang') || 'en';

    if (lang === 'en') {
      return 'us-en';
    } else {
      if (lang === 'id-id' || lang === 'ko-kr') {
        return 'us-en';
      } else {
        return lang?.split('-').reverse().join('-');
      }
    }
  };

  const checkFormLink = () => {
    let formLink = '';
    if (window.location.href.includes('products/storage-defender')) {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52564';
        }
      });
    } else if (window.location.href.includes('flashsystem/cyber-resilience')) {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = `https://www.ibm.com/flashsystem/pricing/${getContryCode()}/contact/cyberassessment`;
        }
      });
    } else if (window.location.href.includes('storage-data-resilience')) {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = `https://www.ibm.com/flashsystem/pricing/${getContryCode()}/contact/cyberassessment`;
        }
      });
    } else {
      selectedItemsArray.map((item: any, i: number) => {
        if (i === 9 && item === 'yes') {
          formLink = 'https://www.ibm.com/account/reg/signup?formid=urx-52720';
        } else {
          formLink = `https://www.ibm.com/flashsystem/pricing/${getContryCode()}/contact/cyberassessment`;
        }
      });
    }
    return formLink;
  };
  const formLink = checkFormLink(); //use this var as the form URL logic
  return (
    <div
      className={parentClass}
      style={{
        backgroundImage: `url("${process.env.PUBLIC_ASSETS_URL}/dora-assessment/images/${resultObject.imageName}-result.png")`,
      }}
    >
      <div className="bx--col-lg-10">
        <div className={`${parentClass}-title`}>
          <h2>{contents[resultObject.title]}</h2>
          <h4>{contents[resultObject.subtitle]}</h4>
        </div>
        <div className={`${parentClass}-copy`}>
          <p>{contents.resultsCopy}</p>
        </div>
        <div className={`${parentClass}-copy`}>
          <h5>{contents.nextStepTitle}</h5>
          <p className="pre-link">
            {contents.nextStepCopy} <strong>{contents.nextStepCopyBold}</strong>
            . {contents.nextStepCopy2}
          </p>
          <a href={formLink} className="link">
            {contents.nextStepCta} <ArrowRight16 />
          </a>
        </div>
        <div className={`${parentClass}-copy`}>
          <h5>{contents.expertsTitle}</h5>
          <p className="pre-link">{contents.expertsCopy}</p>
          <a href="https://www.ibm.com/downloads/cas/AKOGLZDP" className="link">
            {contents.expertsCta} <span>(1.3 MB)</span> <Pdf16 />
          </a>
        </div>
        <Stats contents={contents} formLink={formLink} />
      </div>
    </div>
  );
};

export default Results;
